import {GameFlowController} from '../../components/game-flow-controller.js';
import {MissionManager} from '../../components/mission-manager.js';

export function closeRewards() {
    MissionManager.instance.createNewMissions();
    GameFlowController.instance.closeRewards();
    //Utils.SetActiveRecursively(gameObject, false);
}
